import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { CLIENT_DETAILS_SEED } from '../../../___TEST/clientDetails.seeds';
import { EMPTY_CLIENT } from '../../../___TEST/clientDetails.seeds';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/___LOGIC/__api/api.service';
import { AssetsService } from 'src/app/___LOGIC/__common/_assets/assets.service';

@Component({
  selector: 'app-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.css']
})
export class ClientProfileComponent implements OnInit {

  newClient;
  status;
  apiDomain = environment.urlDash;
  
  constructor(private resolver: ResolverService,
    private commonFunctions: FunctionsService,private guiFlow:GuiFlowService,
    public dialog: MatDialog,private route: ActivatedRoute,private router: Router,
    private apiService: ApiService,private assetsService: AssetsService) {}

  ngOnInit(): void {
    if(this.router.url === '/profile/new') {
      this.status = 'create';
      this.newClient = environment.testingMode? CLIENT_DETAILS_SEED : EMPTY_CLIENT;
    }else{
      this.loadClientDetails();
    }

    /* this.resolver.getBackendDataForQueryId('getThisClientApps',true,response.user_id);
    this.resolver.getBackendDataForQueryId('clientChecklists',true,response.user_id);
    this.resolver.getBackendDataForQueryId('getClientTools',true,response.user_id); */
  }

  loadClientDetails(){
    let id = parseInt(this.route.snapshot.paramMap.get('id'));
      this.status = 'edit';
      this.resolver.setIsLoading('getClientDetails',true);
      this.apiService.getClientDetails((id),'dashboard').subscribe({
        next: (res) => { 
          this.newClient = res; 
          this.resolver.setIsLoading('getClientDetails',false);
          this.commonFunctions.setSelectedClientId(id);
        },
        error: (err) => { 
          this.resolver.setIsLoading('getClientDetails',false);
          this.guiFlow.openSimpleSnackBar('Error loading client data','error');
        }
      });
      //Packs
      this.resolver.getBackendDataForQueryId('getCotizacion',true,'0b4vqasde55mmm3srbu6fnk')
  }

  getUserSelectedInfo(){
    let userSelected = {
      FK_ID_clientDetails: this.commonFunctions.getSelectedClientId()
    };
    return userSelected;
  }

  getStatus(){
    return this.status;
  }

  updateClientProfile(editedObj){
    //this.clientDetails = null;
    this.resolver.updateClientProfile(editedObj);
  }

  createClientProfile(obj){
    this.resolver.createClientProfile(obj).subscribe(
      (res) => {
        let historic = {
        operation: 'save new client Details',
        previousObj: JSON.stringify({}),
        newObj: JSON.stringify(obj),
        FK_ID_clientDetails: null
      };

      this.guiFlow.openSimpleSnackBar('Client details saved','success',null,'');
      //historic.FK_ID_clientDetails = response.OK.records.id;
      //this.commonFunctions.setSelectedClientId(response.OK.records.id);
      //this.processProfileCreation(response,obj);
      //this.getDashboardData(true);
      //this.guiFlow.goToPage('client-board');
      /* this.apiConnector.createHistoric(historic,'clientDetails'); */
      },
      (error) => {}
    );
  }

  loadingProfileInfo(){
    return this.resolver.isLoading('getClientDetails');
  }

  getClientDataObj(){
    // DEBERIA ESTAR RESUELTA PARA CUANDO SE PIDA POR ESO NO PONGO records[0]
    if(this.resolver.getCurrentClientCard()){
      return this.resolver.getCurrentClientCard();
    }else{
      this.newClient = CLIENT_DETAILS_SEED;
      return this.newClient;
    }
  }

  getPhotoUrl(){
    let url;
    if(this.getClientDataObj() && this.getClientDataObj().imageUrl ){
      url = 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/'+this.getClientDataObj().imageUrl+'/public'
    }else{
      url = '';
    }
    return url;
  }

  getFieldValue(field){
    return this.newClient[field];
  }

  getImageUrl(url){
    return this.assetsService.getImageUrl(url);
  }

  convertDate(shortDate){
    return this.commonFunctions.getShortDate(shortDate);
  }

  toLowerCaseObj(field){
    return field.toLowerCase();
  }

  getShortDate(date){
    return this.commonFunctions.getShortDate(date);
  }

  getCssClass(){
    let css = 'profile-cover__action bg-img';
    switch(this.getFieldValue('destination')){
      case 'madrid':
      case 'Madrid':
      case 'MADRID':
        return css + ' madrid';
      case 'barcelona':
      case 'Barcelona':
      case 'Barna':
        return css +  ' barcelona'
      default:
        return css + ' other';
    }
  }

  copyEmail(){
/*     this.regenerate();
    this.emailApi.emailSender('sendMinuta','minuta1',this.getClientDataObj()['email'],this.data).subscribe(
      (response) => {
        this.resolver.processAnswer(response,null,null,'📩');
      },
      (error) => {
        this.resolver.processAnswer(error,null,null,null);
      }
    ); */
  }

  calculateAge(birthday){
    return this.commonFunctions.calculateAge(birthday);
  }

  getLabel(){
    let label;
    this.status == 'create'? label = 'Preview' : label = 'Profile details';
    return label;
  }

  getClientPackages(){
    if(this.resolver.getDependency('getCotizacion') && this.resolver.getDependency('getCotizacion').records){
      return this.resolver.getDependency('getCotizacion').records[0].data;
    }else{
      return [];
    }
  }

}
